module.exports = __webpack_public_path__ + "static/media/image3.00df88d1.webp";